import { site } from '@shared/site.config';
import { useTitle } from '@/lib/useTitle';
import ServiceSheet from '@/components/ServiceSheet';

const service = site.services[2];

const DEAL_SHAPES = ['Business + real property', 'Business + assignable lease', 'Business assets only'];

export default function BusinessListings() {
  useTitle(service.name, service.summary);

  return (
    <ServiceSheet
      sheetNo="A-03"
      service={service}
      glyph="industrial"
      tags={DEAL_SHAPES}
      tagsLabel="Deal shapes"
      /* Singular — the LeadInterest value, not the plural route slug. */
      interest="business-listing"
      ctaLabel="Start a confidential conversation"
      closingLine="Discretion first — nothing goes public without your sign-off."
      note="Buying or selling a business involves matters — valuation, financing, tax structure — outside a real estate salesperson's scope. Expect a referral to work alongside your own accountant and lawyer, not in place of them."
    />
  );
}
